import apiService from './api.service'

export const BASE_PATH = '/lottustech/agendamentosrelatorio'

/** { campo: formula } -> { campo: { data: 'yyyy-MM-dd' } | { erro: '...' } }, calculado para hoje. */
const resolverDatas = (formulas) => apiService.post(`${BASE_PATH}/resolver-datas`, formulas)

/** URL do relatorio em HTML com as datas de hoje; nao envia e-mail. Serve antes de salvar. */
const visualizar = (agendamento) => apiService.post(`${BASE_PATH}/preview`, agendamento)

const salvar = (agendamento) =>
  agendamento.oid
    ? apiService.put(`${BASE_PATH}/${agendamento.oid}`, agendamento)
    : apiService.post(`${BASE_PATH}/`, agendamento)

/** Agendamento completo (o da listagem vem com a projecao reduzida). */
const carregar = (oid) => apiService.get(`${BASE_PATH}/${oid}`)

export { resolverDatas, visualizar, salvar, carregar }
